<template>
  <div class="_hunian" :style="'width: 100vw;height: 100vh;' + transform50">
    <pages :index="pageIndex">
      <!-- 请在手机端打开链接 -->
      <page index="mobile" class="view _mobile">
        <div class="_tip_icon"></div>
        <div class="_tip_text">请在手机端打开链接</div>
      </page>
      <!-- view1 -->
      <page index="view1" class="view view1" @click="clickView1">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/hunian/bg.jpg"
        />
        <img
          class="_1_text animated fadeInDownBig"
          src="http://minio.elfsack.com/h5material/hunian/1_text.png"
        />
        <div
          style="
            position: absolute;
            height: 56%;
            bottom: 20%;
            animation-delay: 0.8s;
            animation-duration: 2s;
          "
          class="animated fadeInUpBig"
        >
          <img
            class="_1_claw"
            src="http://minio.elfsack.com/h5material/hunian/1_claw.png"
          />
        </div>
        <img
          class="_1_wave animated fadeInUpBig"
          src="http://minio.elfsack.com/h5material/hunian/1_wave.png"
        />
        <div
          style="
            position: absolute;
            width: 70%;
            bottom: 13%;
            animation-delay: 0.5s;
          "
          class="animated fadeInUpBig"
        >
          <img
            class="_1_click animated pulse infinite"
            src="http://minio.elfsack.com/h5material/hunian/1_click.png"
            @click="clickView1"
          />
        </div>
        <div
          style="
            position: absolute;
            width: 50%;
            bottom: 8%;
            animation-delay: 0.8s;
          "
          class="animated fadeInUpBig"
        >
          <img
            class="_1_logo animated fadeIn"
            src="http://minio.elfsack.com/h5material/hunian/1_logo.png"
          />
        </div>
      </page>

      <!-- view2 -->
      <page index="view2" class="view view2">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/hunian/bg.jpg"
        />
        <img
          class="_2_claw animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/2_claw.png"
        />
        <img
          class="_2_text animated fadeInLeft"
          src="http://minio.elfsack.com/h5material/hunian/2_text.png"
        />
        <div class="_2_choose">
          <div style="width: 100%; height: 40%; display: flex">
            <div
              style="
                width: 45%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                :class="{
                  _2_choose1: true,
                  _2_choose_active: chooseIndex == 2,
                }"
                src="http://minio.elfsack.com/h5material/hunian/2_choose1.png"
                @click="clickView2(2)"
              />
              <img
                :class="{
                  _2_choose2: true,
                  _2_choose_active: chooseIndex == 4,
                }"
                src="http://minio.elfsack.com/h5material/hunian/2_choose2.png"
                @click="clickView2(4)"
              />
              <img
                :class="{
                  _2_choose3: true,
                  _2_choose_active: chooseIndex == 5,
                }"
                src="http://minio.elfsack.com/h5material/hunian/2_choose3.png"
                @click="clickView2(5)"
              />
            </div>
            <div
              style="
                width: 55%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <div style="position: relative">
                <img
                  :class="{
                    _2_choose4: true,
                    _2_choose_active: chooseIndex == 3,
                  }"
                  src="http://minio.elfsack.com/h5material/hunian/2_choose4.png"
                  @click="clickView2(3)"
                />
                <img
                  class="_2_tiger1 animated fadeInUp"
                  src="http://minio.elfsack.com/h5material/hunian/2_tiger1.png"
                />
              </div>
            </div>
          </div>
          <div style="width: 100%; position: relative">
            <img
              :class="{
                _2_choose5: true,
                _2_choose_active: chooseIndex == 6,
              }"
              src="http://minio.elfsack.com/h5material/hunian/2_choose5.png"
              @click="clickView2(6)"
            />
            <img
              class="_2_heart animated bounceIn"
              src="http://minio.elfsack.com/h5material/hunian/2_heart.png"
            />
          </div>
          <div style="width: 100%; height: 30%; display: flex">
            <div
              style="
                width: 45%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <div style="width: 100%; position: relative">
                <img
                  :class="{
                    _2_choose6: true,
                    _2_choose_active: chooseIndex == 1,
                  }"
                  src="http://minio.elfsack.com/h5material/hunian/2_choose6.png"
                  @click="clickView2(1)"
                />

                <img
                  class="_2_tiger2 animated fadeInDown"
                  src="http://minio.elfsack.com/h5material/hunian/2_tiger2.png"
                />
              </div>
            </div>
            <div
              style="
                width: 55%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                :class="{
                  _2_choose7: true,
                  _2_choose_active: chooseIndex == 7,
                }"
                src="http://minio.elfsack.com/h5material/hunian/2_choose7.png"
                @click="clickView2(7)"
              />
              <img
                :class="{
                  _2_choose8: true,
                  _2_choose_active: chooseIndex == 8,
                }"
                src="http://minio.elfsack.com/h5material/hunian/2_choose8.png"
                @click="clickView2(8)"
              />
            </div>
          </div>
        </div>
      </page>

      <!-- view3 -->
      <page index="view3" class="view view3">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/hunian/bg.jpg"
        />
        <img
          v-if="1 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text1.png"
        />
        <img
          v-if="2 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text2.png"
        />
        <img
          v-if="3 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text3.png"
        />
        <img
          v-if="4 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text4.png"
        />
        <img
          v-if="5 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text5.png"
        />
        <img
          v-if="6 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text6.png"
        />
        <img
          v-if="7 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text7.png"
        />
        <img
          v-if="8 == chooseIndex"
          class="_3_text animated fadeIn"
          src="http://minio.elfsack.com/h5material/hunian/3_text8.png"
        />
        <div
          style="
            top: 60%;
            height: 10%;
            animation-delay: 0.8s;
            position: absolute;
          "
          class="animated fadeInLeft"
        >
          <img
            class="_3_btn animated pulse infinite"
            src="http://minio.elfsack.com/h5material/hunian/3_btn.png"
            @click="clickView3()"
          />
        </div>
        <div
          class="animated rotateInUpLeft"
          style="
            position: absolute;
            bottom: 0;
            right: 0;
            width: 70%;
            animation-delay: 1.3s;
            animation-direction: 2s;
          "
        >
          <img
            class="_3_claw"
            src="http://minio.elfsack.com/h5material/hunian/3_claw.png"
          />
        </div>
      </page>

      <!-- view4 -->
      <page index="view4" class="view view4">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/hunian/bg.jpg"
        />
        <img
          class="_4_text animated fadeInDownBig"
          src="http://minio.elfsack.com/h5material/hunian/4_text.png"
        />
        <div
          style="height: 9%; top: 11%; position: absolute; animation-delay: 1s"
          class="animated fadeInDownBig"
        >
          <img
            v-if="cleIndex == -1"
            class="_4_wallpaper_text animated tada"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_text.png"
          />
          <img
            v-if="cleIndex > -1"
            class="_4_wallpaper_text animated tada"
            src="http://minio.elfsack.com/h5material/hunian/4_cle_text.png"
          />
        </div>
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 1"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_1.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 2"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_2.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 3"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_3.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 4"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_4.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 5"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_5.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 6"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_6.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 7"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_7.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 8"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_8.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 9"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_9.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 10"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_10.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 11"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_11.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 12"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_12.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 13"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_13.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 14"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_14.png"
        />
        <img
          v-if="cleIndex == -1 && wallpaperIndex == 15"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_pre_15.png"
        />

        <img
          v-if="cleIndex == 1"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_cle_1.png"
        />
        <img
          v-if="cleIndex == 2"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_cle_2.png"
        />
        <img
          v-if="cleIndex == 3"
          class="_4_wallpaper animated flipInY"
          src="http://minio.elfsack.com/h5material/hunian/4_cle_3.png"
        />

        <div
          style="
            height: 9%;
            top: 69%;
            position: absolute;
            width: 100%;
            display: flex;
            justify-content: center;
            animation-delay: 4s;
          "
          class="animated rotateIn"
        >
          <img
            v-if="cleIndex > -1"
            class="_4_wallpaper_btn"
            @click="clickView4()"
            src="http://minio.elfsack.com/h5material/hunian/4_cle_btn.png"
          />
          <img
            v-if="cleIndex == -1"
            class="_4_wallpaper_btn"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_btn.png"
          />
          <div
            class="animated fadeInLeftBig"
            style="
              width: 10%;
              height: 80%;
              animation-delay: 4.5s;
              left: 5%;
              top: 6%;
              position: absolute;
              animation-duration: 2s;
              user-select: none;
            "
          >
            <img
              v-if="cleIndex == -1"
              class="_4_wallpaper_tip"
              src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_tip.png"
            />
          </div>
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 1"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_1.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 2"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_2.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 3"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_3.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 4"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_4.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 5"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_5.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 6"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_6.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 7"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_7.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 8"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_8.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 9"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_9.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 10"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_10.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 11"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_11.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 12"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_12.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 13"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_13.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 14"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_14.jpg"
          />
          <img
            v-if="cleIndex == -1 && wallpaperIndex == 15"
            class="_4_wallpaper_save"
            src="http://minio.elfsack.com/h5material/hunian/4_wallpaper_15.jpg"
          />
        </div>
        <img
          class="_4_coin1 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin1.png"
        />
        <img
          class="_4_coin2 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin2.png"
        />
        <img
          class="_4_coin3 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin3.png"
        />
        <img
          class="_4_coin4 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin4.png"
        />
        <img
          class="_4_claw animated fadeInUpBig"
          src="http://minio.elfsack.com/h5material/hunian/4_claw.png"
        />
      </page>

      <!-- view5 -->
      <page index="view5" class="view view5">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/hunian/bg.jpg"
        />
        <img
          class="_5_logo animated fadeInDownBig"
          src="http://minio.elfsack.com/h5material/hunian/1_logo.png"
        />
        <div style="position: relative; width: 60%; z-index: 2; margin: -2% 0">
          <img
            class="_5_name animated fadeInRightBig"
            src="http://minio.elfsack.com/h5material/hunian/5_name.png"
          />
          <input
            v-model="name"
            style="right: 11%; width: 55%; height: 30%; top: 35%"
          />
        </div>
        <div style="position: relative; width: 60%; margin: -2% 0; z-index: 2">
          <img
            class="_5_mobile animated fadeInRightBig"
            src="http://minio.elfsack.com/h5material/hunian/5_mobile.png"
          />
          <input
            v-model="mobile"
            style="left: 12%; width: 74%; height: 30%; top: 45%"
          />
        </div>
        <div style="position: relative; width: 60%; margin: -4% 0; z-index: 2">
          <img
            class="_5_address animated fadeInRightBig"
            src="http://minio.elfsack.com/h5material/hunian/5_address.png"
          />
          <textarea
            v-model="address"
            style="left: 12%; width: 77%; height: 52%; top: 30%"
          />
        </div>
        <img
          @click="clickView5()"
          class="_5_btn animated rotateIn"
          src="http://minio.elfsack.com/h5material/hunian/5_btn.png"
        />
        <div class="_5_tip animated bounceIn">
          <div class="animated pulse infinite">
            <p>*获奖提示：记得截图保存噢！</p>
            <p>礼物会按时发出，请耐心等待</p>
          </div>
        </div>
        <img
          class="_5_coin1 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin1.png"
        />
        <img
          class="_5_coin2 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin2.png"
        />
        <img
          class="_5_coin3 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin3.png"
        />
        <img
          class="_5_coin4 animated bounceInDown"
          src="http://minio.elfsack.com/h5material/hunian/4_coin4.png"
        />
        <img
          class="_5_claw animated fadeInUpBig"
          src="http://minio.elfsack.com/h5material/hunian/4_claw.png"
        />
      </page>
    </pages>

    <audio
      id="bgmPlay"
      src="http://minio.elfsack.com/h5material/hunian/bgm.mp3"
      class="media-audio"
      loop
      autoplay
      preload
      ref="bgmPlay"
    ></audio>
    <img
      v-if="!bgmState"
      @click="playBgm()"
      class="_bgm _bgm0"
      src="http://minio.elfsack.com/h5material/hunian/bg_0.png"
    />
    <img
      v-if="bgmState"
      @click="stopBgm()"
      class="_bgm _bgm1"
      src="http://minio.elfsack.com/h5material/hunian/bg_1.png"
    />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";

export default {
  name: "app",
  data() {
    return {
      htmlWidth: 0,
      htmlHeight: 0,
      transform50: "",
      pageIndex: "view1",
      chooseIndex: "",
      bgmState: true,
      lotteryState: false,
      cleIndex: -1,
      wallpaperIndex: 1,
      name: "",
      mobile: "",
      address: "",
    };
  },
  created() {
    let _this = this;

    // 设置标题
    document.title = "选择“虎年关键词”";

    // 屏幕高度、宽度
    _this.htmlHeight = window.innerHeight;
    _this.htmlWidth = window.innerWidth;

    if (!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
      _this.pageIndex = "mobile";
    }

    document.addEventListener(
      "WeixinJSBridgeReady",
      function () {
        _this.playBgm();

        // 屏幕高度、宽度
        _this.htmlHeight = window.innerHeight;
        _this.htmlWidth = window.innerWidth;
      },
      false
    );

    let appId = "wx78058959e36d4115";
    let url = window.location.href.split("#")[0];

    _this.$http
      .post(
        "http://gw.api.elfsack.com/open/api/wechat/common/createApiTicket",
        {
          appId: appId,
          url: url,
        }
      )
      .then(function (response) {
        if (response.data.code == "1") {
          let retData = response.data.data;
          wx.config({
            debug: false,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: retData.timestamp, // 必填，生成签名的时间戳
            nonceStr: retData.nonceStr, // 必填，生成签名的随机串
            signature: retData.signature, // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "getNetworkType",
              "openLocation",
              "getLocation",
              "hideOptionMenu",
              "showOptionMenu",
              "hideMenuItems",
              "showMenuItems",
              "hideAllNonBaseMenuItem",
              "showAllNonBaseMenuItem",
              "closeWindow",
              "scanQRCode",
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ],
          });

          var wxshare = {
            initcont1: {
              title: "选择“虎年关键词”",
              desc: "接受你的爆炸好运吧！",
              link: "http://h5.elfsack.com/hunian/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "http://minio.elfsack.com/h5material/common/share.jpg", // 分享图标
            },
          };
          wx.ready(function () {
            wx.onMenuShareAppMessage(wxshare.initcont1);
            wx.onMenuShareTimeline(wxshare.initcont1);
            wx.onMenuShareQQ(wxshare.initcont1);
            wx.onMenuShareWeibo(wxshare.initcont1);
            wx.onMenuShareQZone(wxshare.initcont1);
            wx.updateAppMessageShareData(wxshare.initcont1);
            wx.updateTimelineShareData(wxshare.initcont1);
          });
        }
      });
  },
  mounted() {},
  methods: {
    clickView1() {
      this.playBgm();
      this.pageIndex = "view2";
    },
    clickView2(chooseIndex) {
      let _this = this;
      _this.chooseIndex = chooseIndex;
      _this.cleIndex = -1;
      _this.wallpaperIndex = Math.ceil(Math.random() * 15);

      // 活动结束
      // // 请求后台计算抽奖结果，并生成保存图片
      // _this.$http
      //   .post("http://digital.api.elfsack.com/hunian/lottery", {})
      //   .then(function (response) {
      //     let index = response.data.data;
      //     _this.cleIndex = index;
      //   });

      setTimeout(function () {
        _this.pageIndex = "view3";
      }, 1000);
    },
    clickView3() {
      this.pageIndex = "view4";
    },
    clickView4() {
      this.pageIndex = "view5";
    },
    clickView5() {
      let _this = this;
      if (!_this.name || !_this.mobile || !_this.address) {
        alert("请完善信息！");
        return;
      }

      // 保存地址
      _this.$http
        .post("http://digital.api.elfsack.com/hunian/saveAddress", {
          name: _this.name,
          mobile: _this.mobile,
          address: _this.address,
          cleIndex: _this.cleIndex,
        })
        .then(function (response) {
          if (response.data.code == "1") {
            _this.chooseIndex = -1;
            _this.cleIndex = -1;
            _this.mobile = "";
            _this.address = "";
            _this.cleIndex = "";
            alert("保存成功！");
            setTimeout(function () {
              _this.pageIndex = "view1";
            }, 1000);
          } else {
            alert("活动太火爆了！请稍后重试");
          }
        });
    },
    playBgm() {
      this.bgmState = true;
      this.$refs.bgmPlay.play();
      console.log(this.bgmState);
    },
    stopBgm() {
      this.bgmState = false;
      this.$refs.bgmPlay.pause();
    },
  },
};
</script>



<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

._tip_icon {
  height: 100px;
  background-image: url(http://minio.elfsack.com/h5material/common/icon.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 5% 0;
}

._tip_text {
  text-align: center;
  font-size: 18px;
}

.view {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  position: relative;

  img {
    position: absolute;
  }
}

._bg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

._bgm {
  position: absolute;
  top: 2%;
  right: 3%;
  z-index: 99;
  object-fit: contain;
}

._bgm0 {
  width: 30px;
  height: 30px;
}
._bgm1 {
  width: 30px;
  height: 30px;
}

.view1 {
  ._1_text {
    width: 71%;
    top: 5%;
  }

  ._1_claw {
    height: 100%;
    position: unset;
    animation: _1_claw_ani 3s infinite;
    animation-delay: 1.5s;
    transform: rotateZ(-5deg) translateX(-7%) translateY(5%);
  }

  @keyframes _1_claw_ani {
    0% {
      transform: rotateZ(-5deg) translateX(-7%) translateY(5%);
    }
    50% {
      transform: rotateZ(5deg) translateX(20%) translateY(-5%);
    }
    100% {
      transform: rotateZ(-5deg) translateX(-7%) translateY(5%);
    }
  }

  ._1_wave {
    height: 42%;
    bottom: -5%;
    width: 100%;
    animation-delay: 0.1s;
  }

  ._1_click {
    width: 100%;
    position: unset;
    animation-delay: 3.5s;
  }

  ._1_logo {
    width: 100%;
    position: unset;
  }
}

.view2 {
  ._2_claw {
    top: 0;
    height: 20%;
    animation-delay: 0.1s;
  }

  ._2_text {
    top: 15%;
    height: 10%;
  }

  ._2_choose {
    position: relative;
    top: 10%;
    width: 80%;
    height: 74%;
    display: flex;
    justify-content: center;
    align-self: center;
    flex-direction: column;

    ._2_choose1 {
      position: unset;
      width: 100%;
      margin: -7% 0;
    }

    ._2_choose2 {
      position: unset;
      width: 100%;
      margin: -7% 0;
    }
    ._2_choose3 {
      position: unset;
      width: 100%;
      margin: -7% 0;
    }
    ._2_choose4 {
      position: unset;
      width: 100%;
    }
    ._2_choose5 {
      position: unset;
      width: 100%;
    }
    ._2_choose6 {
      position: unset;
      width: 100%;
    }
    ._2_choose7 {
      position: unset;
      width: 100%;
    }
    ._2_choose8 {
      position: unset;
      width: 100%;
    }
    ._2_tiger1 {
      height: 50%;
      top: 67%;
      right: 14%;
      z-index: 2;
    }
    ._2_tiger2 {
      height: 80%;
      bottom: 7%;
      left: 56%;
      z-index: 2;
    }
    ._2_heart {
      width: 16%;
      top: -7%;
      left: 6%;
      z-index: 2;
    }

    ._2_choose_active {
      animation: _2_choose_active_ani 1s;
    }

    @keyframes _2_choose_active_ani {
      0% {
        transform: rotateY(0deg);
      }
      100% {
        transform: rotateY(360deg);
      }
    }
  }
}

.view3 {
  ._3_text {
    height: 70%;
    margin-right: -6%;
    top: 0;
    animation-duration: 3s;
  }
  ._3_btn {
    position: unset;
    height: 100%;
    animation-delay: 2.5s;
  }
  ._3_claw {
    width: 100%;
    height: 100%;
    position: unset;
    display: block;
    animation: _3_claw_ani 3s infinite;
    animation-delay: 2.5s;
    transform: rotateZ(-5deg) translateX(3%) translateY(5%);
  }

  @keyframes _3_claw_ani {
    0% {
      transform: rotateZ(-5deg) translateX(3%) translateY(5%);
    }
    50% {
      transform: rotateZ(5deg) translateX(6%) translateY(-3%);
    }
    100% {
      transform: rotateZ(-5deg) translateX(3%) translateY(5%);
    }
  }
}

.view4 {
  ._4_text {
    height: 13%;
    top: 2%;
    animation-delay: 1s;
  }
  ._4_wallpaper_text {
    height: 100%;
    position: unset;
    animation-delay: 2s;
    animation-iteration-count: 2;
  }
  ._4_wallpaper {
    height: 55%;
    top: 16%;
    animation-delay: 1s;
  }

  ._4_wallpaper_save {
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 3;
    user-select: none;
  }
  ._4_wallpaper_btn {
    height: 100%;
    animation-delay: 4.1s;
    user-select: none;
  }

  ._4_wallpaper_tip {
    height: 100%;
    width: 100%;
    object-fit: contain;
    animation-delay: 6s;
    animation-duration: 5s;
    animation: _4_wallpaper_tip_ani infinite 1s;
  }

  @keyframes _4_wallpaper_tip_ani {
    0% {
      transform: translateX(-10%);
    }
    50% {
      transform: translateX(10%);
    }
    100% {
      transform: translateX(-10%);
    }
  }

  ._4_coin1 {
    max-height: 7%;
    top: 80%;
    left: 14%;
    max-width: 11%;

    animation-delay: 0.1s;
  }

  ._4_coin2 {
    top: 78%;
    right: 12%;
    max-height: 7%;
    max-width: 11%;
  }

  ._4_coin3 {
    top: 64%;
    right: 5%;
    max-height: 7%;
    max-width: 11%;

    animation-delay: 0.2s;
  }

  ._4_coin4 {
    top: 40%;
    left: 3%;
    max-height: 7%;
    max-width: 11%;
    animation-delay: 0.3s;
  }

  ._4_claw {
    height: 24%;
    bottom: 0;
    animation: _4_claw_ani 3s forwards;
    transform: translateY(100%);
    animation-delay: 2s;
  }
  @keyframes _4_claw_ani {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
}

.view5 {
  ._5_logo {
    width: 50%;
    position: unset;
  }

  input,
  textarea {
    position: absolute;
    border: none;
    background-color: #fff0;
    outline: none;
    line-height: 1.2rem;
    font-size: 1.2rem;
    caret-color: #000;
  }

  ._5_name {
    width: 100%;
    position: unset;
    animation-delay: 0.4s;
  }

  ._5_mobile {
    width: 100%;
    position: unset;
    animation-delay: 0.6s;
    input {
      right: 11%;
      width: 55%;
      height: 30%;
      top: 34%;
    }
  }
  ._5_address {
    width: 100%;
    position: unset;
    animation-delay: 0.8s;
  }

  ._5_btn {
    height: 9%;
    position: unset;
    z-index: 3;
    animation-delay: 2s;
    margin-top: -2%;
  }

  ._5_tip {
    margin: 2% 0 30% 0;
    z-index: 2;
    color: #fff;
    font-size: 0.8rem;
    font-weight: bold;
    animation-delay: 3s;
  }

  ._5_tip > div {
    animation-delay: 3.3s;
  }

  ._5_coin1 {
    max-height: 7%;
    top: 80%;
    left: 14%;
    max-width: 11%;
    animation-delay: 0.1s;
  }

  ._5_coin2 {
    top: 78%;
    right: 12%;
    max-height: 7%;
    max-width: 11%;
  }

  ._5_coin3 {
    top: 64%;
    right: 5%;
    max-height: 7%;
    max-width: 11%;
    animation-delay: 0.2s;
  }

  ._5_coin4 {
    top: 40%;
    left: 3%;
    max-height: 7%;
    max-width: 11%;
    animation-delay: 0.3s;
  }

  ._5_claw {
    height: 24%;
    bottom: 0;
    animation: _5_claw_ani 2s forwards;
    transform: translateY(100%);
    animation-delay: 0.5s;
  }
  @keyframes _5_claw_ani {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
